export default "__VITE_ASSET__BQcL2r8t__"